





























import Swal from 'sweetalert2';
import Vue, { PropType } from 'vue'
import { Aprovacao, StatusAprovacao } from '../../../../store/livro-digital/aprovacoes-respotiroy';

export default Vue.extend({
    props: {
        aprovacao: {
            type: Object as PropType<Aprovacao>,
            required: true
        }
    },
    methods: {
        showRessalvas() {
            if (this.aprovacao.Ressalva.trim() === '') {
                return
            }

            const html = `<p>${this.aprovacao.Ressalva.replace("\n", '<br />')}</p>`
            Swal.fire({
                title: "Ressalvas",
                html
            })
        }
    },
    computed: {
        status() {
            switch (this.aprovacao.Status) {
                case StatusAprovacao.PENDENTE:
                    return 'Pendente'
                case StatusAprovacao.APROVADO:
                    return 'Aprovada'
                case StatusAprovacao.REPROVADO:
                    return 'Reprovada'
                case StatusAprovacao.APROVADO_COM_RESSALVA:
                    return 'Aprovado com ressalva'
                default:
                    return ''
            }
        },
        classe() {
            switch (this.aprovacao.Status) {
                case StatusAprovacao.PENDENTE:
                    return 'pendente'
                case StatusAprovacao.APROVADO:
                    return 'aprovado'
                case StatusAprovacao.REPROVADO:
                    return 'reprovado'
                case StatusAprovacao.APROVADO_COM_RESSALVA:
                    return 'ressalva'
                default:
                    return ''
            }
        }
    }
})

